/** Reset before measuring detail tiers so growing the viewport restores full size. */
export function resetPipScale(root: HTMLElement): void {
  for (const property of ['width', 'height', 'transform', 'transform-origin']) root.style.removeProperty(property)
  delete root.dataset.scale
}

/** Last resort after hiding secondary data. The host remains the real viewport;
 * expand an unscaled layout canvas, then fit that canvas back into the host.
 * This imposes no minimum viewport size and preserves complete text and controls.
 */
export function fitPipScale(root: HTMLElement, fits: (root: HTMLElement) => boolean, maxExpansion = Infinity): number {
  if (fits(root)) return 1
  const measure = (scale: number) => {
    root.style.width = `${100 / scale}%`
    root.style.height = `${100 / scale}%`
    return fits(root)
  }
  let upper = 1
  const minimum = 1 / Math.max(1, maxExpansion)
  let lower = Math.max(.5, minimum)
  // Bounded work even if a broken asset or external stylesheet never fits.
  for (let attempt = 0; attempt < 24 && !measure(lower); attempt++) {
    if (lower <= minimum) break
    upper = lower
    lower = Math.max(lower / 2, minimum)
  }
  for (let attempt = 0; attempt < 8; attempt++) {
    const middle = (lower + upper) / 2
    if (measure(middle)) lower = middle
    else upper = middle
  }
  measure(lower)
  root.style.transformOrigin = 'top left'
  root.style.transform = `scale(${lower})`
  root.dataset.scale = String(lower)
  return lower
}
